var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('el-container',{attrs:{"id":"container"}},[_c('vue-page-transition',{attrs:{"name":"fade"}},[_c('router-view',{staticClass:"view"})],1),_c('el-footer',[_vm._v("Happy Birthday Ana Badurina")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }